// npm run - start app on localhost

// GIT COMMANDS USED
// git add .
// git commit -m ' commit to gh-pages branch ? '
// git push origin master
// git push
// npm run build
// npm run deploy

// JSON SETTINGS
//  https://mdugg.github.io/folio20/
// "predeploy": "npm run build",
// "deploy": "gh-pages -d build" <-- branch
// "deploy": "gh-pages -b master -d build"

// INSTALLATIONS
// --save makes installation a dependency in package.json
// npm install --save react-router
// npm install --save react-router-dom
// npm install -s node-sass
// npm i --save @fortawesome/fontawesome-svg-core  @fortawesome/free-solid-svg-icons @fortawesome/react-fontawesome
// npm install react-bootstrap bootstrap
// npm install react-player
// npm i --save font-awesome
// npm i --save @fortawesome/free-brands-svg-icons
// npm add react-spring-lightbox styled-components
// npm i react-ga -S  (google analytics - https://github.com/react-ga/react-ga // https://levelup.gitconnected.com/using-google-analytics-with-react-3d98d709399b)
// npm install react-hotjar --save  - https://www.npmjs.com/package/react-hotjar
// $ npm install --save react-router-hash-link  -  https://github.com/rafgraph/react-router-hash-link

import React from "react";
import { render } from "react-dom";
import App from "./App";
import { HashRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./stylesheets/_app.scss";
// Google Analytics ::
// import ReactGA from "react-ga";
// ReactGA.initialize("UA-5626604-2");

// Hotjar ::
// import { hotjar } from "react-hotjar";
// hotjar.initialize(1556713, 6);

//Hide hotjar while in dev
(function (h, o, t, j, a, r) {
	h.hj =
		h.hj ||
		function () {
			(h.hj.q = h.hj.q || []).push(arguments);
		};
	h._hjSettings = { hjid: 1556713, hjsv: 6 };
	a = o.getElementsByTagName("head")[0];
	r = o.createElement("script");
	r.async = 1;
	r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
	a.appendChild(r);
})(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");

render(
	<HashRouter>
		<App />
	</HashRouter>,
	document.getElementById("root")
);
